import React, { Component, Fragment } from "react";

export default class SelectCampo extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            modalidades: [
                "5 Iniciação Profissional",
                "5 Iniciação Profissional (EAD)",
                "11 Aprendizagem Industrial básica",
                "11 Aprendizagem Industrial básica (EAD)",
                "15 Aprendizagem Industrial Técnica de Nível Médio",
                "15 Aprendizagem Industrial Técnica de Nível Médio (EAD)",
                "21 Qualificação Profissional",
                "21 Qualificação Profissional (EAD)",
                "22 Qualificação Profissional - Itinerário V Ensino Médio",
                "58 Aperfeiçoamento/Especialização Profissional",
                "58 Aperfeiçoamento/Especialização Profissional (EAD)",
                "31 Técnico de Nível Médio",
                "31 Técnico de Nível Médio (EAD)",
                "41 Graduação Tecnológica",
                "41 Graduação Tecnológica (EAD)",
                "87 Cursos de Extensão",
                "87 Cursos de Extensão (EAD)",
                '91 Pós-Graduação "Lato-Sensu" - Especialização',
                '91 Pós-Graduação "Lato-Sensu" - Especialização(EAD)',
                "32 Técnico de Nível Médio - Itinerário V Ensino Médio",
                "32 Técnico de Nível Médio - Itinerário V Ensino Médio (EAD)",
                "57 Aperfeiçoamento Profissional",
                "57 Aperfeiçoamento Profissional (EAD)",
                "Todas"
            ],
            unidades: [
                "DR",
                "5201183 Faculdade SENAI da Paraíba",
                "1117489 Centro de Formação Profissional Professor Stenio Lopes",
                "1117490 Centro de Inovação e Tecnologia Industrial - CITI",
                "1117488 Centro de Educação Profissional Odilon Ribeiro Coutinho",
                "1117487 Centro de Formação Prof. Eng. Jose William Lemos Leal",
                "1117491 Centro de Tecnologia do Couro e do Calçado Albano Franco",
                "5140965 Centro de Formação Profissional Miriam Benevides Gadelha",
                "1169095 Centro de Ações Móveis - CAM",
                "5297028 Centro de Formação Profissional Robson Braga de Andrade\t"
            ],
            tipos: [
                "metas",
                "realizados",
                "metasrealizados"
            ],
            campos: [
                "matricula",
                "hora"
            ],
            visao: [
                "mensal",
                "acumulado"
            ]
        }
    }

    render() {
        let { campo } = this.props;
        return (
            <Fragment>
                    <form>
                        <div className="form-group">
                            <label className="text-capitalize">{campo || "modalidade"}: </label>
                            <select name="select" onChange={this.props.select} className="form-control" id={this.props.idComponente || "selectModalidade"}>
                                {this.state[campo || "modalidades"].map(modalidade => {
                                    return(
                                        <option value={modalidade}>{modalidade}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </form>
            </Fragment>
        )
    }
}